import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeuix/themes';
export const MyPreset = definePreset(Aura, {
  primitive: {
    typography: {
      font: {
        size: '14px',
      },
    },
  },
  semantic: {
    primary: {
      50: '#EFF6FF',
      100: '#DBEAFE',
      200: '#BFDBFE',
      300: '#93C5FD',
      400: '#60A5FA',
      500: '#3B82F6',
      600: '#2563EB',
      700: '#1D4ED8',
      800: '#1E40AF',
      900: '#1E3A8A',
      950: '#172554',
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '6px',
        paddingY: '10px',
        paddingX: '1rem',
      },
      colorScheme: {
        light: {
          text: {
            info: {
              color: '#3B82F6',
            },
          },
        },
      },
    },
    inputtext: {
      root: {
        borderRadius: '6px',
        paddingY: '10px',
        placeholderColor: '#61646B',
        borderColor: '#C9CDD2',
        disabledBackground: '#F3F4F6',
        disabledColor: '#4B5563',
        lg: {
          fontSize: '0.875rem',
        },
      },
    },
    select: {
      root: {
        borderRadius: '6px',
        paddingY: '10px',
        placeholderColor: '#61646B',
        borderColor: '#C9CDD2',
        lg: {
          fontSize: '0.875rem',
        },
      },
    },
    multiselect: {
      root: {
        borderRadius: '6px',
        paddingY: '10px',
        placeholderColor: '#61646B',
        borderColor: '#C9CDD2',
        lg: {
          fontSize: '0.875rem',
        },
      },
    },
    textarea: {
      root: {
        borderRadius: '6px',
        paddingY: '10px',
        placeholderColor: '#61646B',
        borderColor: '#C9CDD2',
        lg: {
          fontSize: '0.875rem',
        },
      },
    },
    divider: {
      root: { borderColor: '#E0E3E6' },
    },
    tabs: {
      tablist: {
        borderWidth: '0',
      },
      tab: {
        activeBackground: '#EFF8FE',
        activeBorderColor: '#EFF8FE',
        color: '#272A31',
        activeColor: '#0368A0',
        hoverColor: '#0368A0',
        hoverBackground: '#EFF8FE',
        hoverBorderColor: '#EFF8FE',
        padding: '10px 16px',
        fontWeight: '500',
        gap: '8px',
      },
    },
  },
});
